export default function Spinner() {
  return (
    <div className="spinner-container">
      <div className="survey-loader" />
    </div>
  );
}
